import {createApi} from '@reduxjs/toolkit/query/react';
import {customBaseQuery} from '~/common/rtk-query/queries';

export const api = createApi({
  reducerPath: 'guestsApi',
  baseQuery: customBaseQuery({basePath: '/ajax'}),
  tagTypes: ['Guests', 'Contacts'],
  endpoints: () => ({}),
});
